import {
  Box,
  Card,
  CardContent,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select as MuiSelect,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { spacing } from "@mui/system";
import axios from "axios";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Select = styled(MuiSelect)(spacing);
const TextField = styled(MuiTextField)(spacing);

export default (props) => {
  const editData = props.editData;
  const onFieldChange = props.onFieldChange;
  const moveOut = props.moveOut;
  const action = props.action;
  const handleClose = props.handleClose;
  const properties = props.properties.data.propertiesList.items;

  let readTypeCheckedInitialState = "";

  if (moveOut.readAmtType == "EST") readTypeCheckedInitialState = "EST";
  if (moveOut.readAmtType == "ACT") readTypeCheckedInitialState = "ACT";

  const [units, setUnits] = useState([]);
  const [areUnitsLoading, setAreUnitsLoading] = useState(false);
  const unitsFetchSeq = useRef(0);
  const [unitMeters, setUnitMeters] = useState([]);
  const onMeterReadChange = props.onMeterReadChange;

  const [readTypeChecked, setReadTypeChecked] = useState(
    readTypeCheckedInitialState
  );

  const handleReadTypeChange = (type) => {
    if (readTypeChecked == type) setReadTypeChecked("");
    else setReadTypeChecked(type);
  };

  useEffect(() => {
    if (isEmpty(moveOut) || !moveOut.propertyUuid) return;
    if (!properties || !properties.length) return;
    const ind = properties.findIndex((elem) => elem.uuid == moveOut.propertyUuid);
    if (ind === -1) return;
    const propertyId = properties[ind].id;
    const seq = ++unitsFetchSeq.current;
    setUnits([]);
    setAreUnitsLoading(true);
    axios
      .get(`/unit/property/${propertyId}`)
      .then((res) => {
        if (seq !== unitsFetchSeq.current) return;
        setUnits(Array.isArray(res.data) ? res.data : []);
        setAreUnitsLoading(false);
      })
      .catch((err) => {
        if (seq !== unitsFetchSeq.current) return;
        console.log(err);
        setAreUnitsLoading(false);
      });
  }, [moveOut?.uuid, moveOut?.propertyUuid, properties?.length]);

  useEffect(() => {
    if (isEmpty(moveOut) || !moveOut.unitUuid) {
      setUnitMeters([]);
      return;
    }
    axios
      .get(`/unit/${moveOut.unitUuid}/meter`)
      .then((res) => {
        const meters = Array.isArray(res.data) ? res.data : res.data?.meters || [];
        setUnitMeters(meters);
      })
      .catch(() => setUnitMeters([]));
  }, [moveOut?.uuid, moveOut?.unitUuid]);

  const extraMeters = unitMeters.filter((meter) => String(meter.id) !== String(moveOut.meterId));

  return (
    <div>
      {isEmpty(moveOut) ? (
        <div>Loading</div>
      ) : (
        <Card elevation={2}>
          <CardContent sx={{ p: 2 }}>
            {/* Contact Information Section */}
            <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
              <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600, mb: 1.5 }}>
                Contact Information
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                  <TextField
                    label="Email Address"
                    type="email"
                    onChange={onFieldChange}
                    name="email"
                    defaultValue={moveOut.email}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                  <TextField
                    label="Phone Number"
                    type="tel"
                    onChange={onFieldChange}
                    name="phone"
                    defaultValue={moveOut.phone}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
              </Box>
            </Paper>

            {/* Forwarding Address Section */}
            <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
              <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600, mb: 1.5 }}>
                Forwarding Address
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ flex: '1 1 100%' }}>
                  <TextField
                    label="Address Line 1"
                    type="text"
                    onChange={onFieldChange}
                    name="fwdAddress1"
                    defaultValue={moveOut.fwdAddress1}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                <Box sx={{ flex: '1 1 100%' }}>
                  <TextField
                    label="Address Line 2 (Optional)"
                    type="text"
                    onChange={onFieldChange}
                    name="fwdAddress2"
                    defaultValue={moveOut.fwdAddress2}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                  <TextField
                    label="City"
                    type="text"
                    onChange={onFieldChange}
                    name="fwdCity"
                    defaultValue={moveOut.fwdCity}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(25% - 8px)' } }}>
                  <TextField
                    label="State"
                    type="text"
                    onChange={onFieldChange}
                    name="fwdState"
                    defaultValue={moveOut.fwdState}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(25% - 8px)' } }}>
                  <TextField
                    label="ZIP Code"
                    type="text"
                    onChange={onFieldChange}
                    name="fwdZip"
                    defaultValue={moveOut.fwdZip}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
              </Box>
            </Paper>

            {/* Unit Information Section */}
            <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
              <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600, mb: 1.5 }}>
                Unit Information
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <FormControl fullWidth size="small">
                    <InputLabel id="edit-moveout-property-label">Property</InputLabel>
                    {properties && properties.length > 0 ? (
                    <Select
                      key={`property-${moveOut.uuid}-${properties.length}`}
                      labelId="edit-moveout-property-label"
                      id="propertyUuid"
                      label="Property"
                      onChange={onFieldChange}
                      defaultValue={moveOut.propertyUuid ?? ""}
                      name="propertyUuid"
                      variant="outlined"
                    >
                      {properties.map((item, index) => (
                        <MenuItem value={item.uuid} key={index}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                    ) : (
                    <Select
                      key={`property-${moveOut.uuid}-empty`}
                      labelId="edit-moveout-property-label"
                      id="propertyUuid"
                      label="Property"
                      disabled
                      defaultValue=""
                      variant="outlined"
                    >
                      <MenuItem value="">No properties loaded</MenuItem>
                    </Select>
                    )}
                  </FormControl>
                </Box>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="edit-moveout-unit-label">Unit</InputLabel>
                    {units && units.length ? (
                      <Select
                        key={`unit-${moveOut.uuid}-${units.length}`}
                        labelId="edit-moveout-unit-label"
                        id="unitUuid"
                        label="Unit"
                        onChange={onFieldChange}
                        defaultValue={moveOut.unitUuid ?? ""}
                        name="unitUuid"
                        variant="outlined"
                      >
                        {units.map((item, index) => (
                          <MenuItem value={item.uuid} key={index}>
                            {item.address1 + " " + item.address2}
                          </MenuItem>
                        ))}
                      </Select>
                    ) : (
                      <Select
                        labelId="edit-moveout-unit-label"
                        id="unitUuid"
                        label="Unit"
                        disabled
                        defaultValue=""
                        variant="outlined"
                      >
                        <MenuItem value="">
                          {areUnitsLoading ? "Loading units…" : "No units available"}
                        </MenuItem>
                      </Select>
                    )}
                  </FormControl>
                </Box>
              </Box>
            </Paper>

            {/* Move Information Section */}
            <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
              <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600, mb: 1.5 }}>
                Move Information
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                  <TextField
                    label="Move Out Date"
                    type="date"
                    onChange={onFieldChange}
                    name="moveOutDate"
                    defaultValue={moment.utc(moveOut.moveOutDate).format(
                      "YYYY-MM-DD"
                    )}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                  <TextField
                    label={moveOut.meterNum ? `Meter #${moveOut.meterNum} reading` : "Final Meter Reading"}
                    type="number"
                    onChange={onFieldChange}
                    name="meterRead"
                    defaultValue={moveOut.meterRead}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                {extraMeters.map((meter) => (
                  <Box key={meter.id} sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <TextField
                      label={`Meter #${meter.meterNum} reading`}
                      type="number"
                      onChange={(e) => onMeterReadChange && onMeterReadChange(meter.id, e.target.value)}
                      name={`meterReads.${meter.id}`}
                      defaultValue={
                        moveOut.secondMeter && String(moveOut.secondMeter.meterId) === String(meter.id)
                          ? moveOut.secondMeter.meterRead
                          : ""
                      }
                      fullWidth
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                ))}
                {moveOut.meterRead != 0 && (
                  <Box sx={{ flex: '1 1 100%', mt: 1.5 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                      Reading Type
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={readTypeChecked == "ACT" ? true : false}
                            onChange={(e) => {
                              handleReadTypeChange("ACT");
                              onFieldChange(e);
                            }}
                            name="readAmtType"
                            value="ACT"
                            color="primary"
                          />
                        }
                        label="Actual Reading"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={readTypeChecked == "EST" ? true : false}
                            onChange={(e) => {
                              handleReadTypeChange("EST");
                              onFieldChange(e);
                            }}
                            name="readAmtType"
                            value="EST"
                            color="primary"
                          />
                        }
                        label="Estimated Reading"
                      />
                    </Box>
                  </Box>
                )}
                {moveOut.meterRead == 0 && (
                  <Box sx={{ flex: '1 1 100%', mt: 1.5 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                      Reading Type
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={readTypeChecked == "ACT" ? true : false}
                            onChange={(e) => {
                              handleReadTypeChange("ACT");
                              onFieldChange(e);
                            }}
                            disabled={true}
                            name="readAmtType"
                            value="ACT"
                            color="primary"
                          />
                        }
                        label="Actual Reading"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={readTypeChecked == "EST" ? true : false}
                            disabled={true}
                            onChange={(e) => {
                              handleReadTypeChange("EST");
                              onFieldChange(e);
                            }}
                            name="readAmtType"
                            value="EST"
                            color="primary"
                          />
                        }
                        label="Estimated Reading"
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Paper>

            {/* Action Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, pt: 1.5 }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleClose}
                size="medium"
                sx={{ minWidth: 100 }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  action();
                  handleClose();
                }}
                size="medium"
                sx={{ minWidth: 100 }}
              >
                Save Changes
              </Button>
            </Box>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
